import { CustomerLoyaltyDto } from './customer-loyalty.dto';
import { CustomerDto } from './customer.dto';
import { CustomerAddressDto } from './customerAddress.dto';
import { CustomerFavoriteDto } from './customerFavorite.dto';
import { CustomerPaymentTypeDto } from './customerPaymentType.dto';
import { GiftCardDto } from './gift-card';
import { OrderDto } from './order.dto';

export class CustomerProfileDto {
  customer: CustomerDto;
  customerAddresses?: CustomerAddressDto[];
  customerPaymentMethods?: CustomerPaymentTypeDto[];
  customerOrders?: OrderDto[];
  customerLoyalty?: CustomerLoyaltyDto[];
  customerFavourites?: CustomerFavoriteDto[];
  totalCustomerOrderCount?: number;
  customerGiftCards?: GiftCardDto[];
  insideArea?: boolean;
}

export class CustomerProfileDtoV2 {
  customer: CustomerDto;
}
